import script from "./FilterUsers.vue?vue&type=script&lang=ts&setup=true"
export * from "./FilterUsers.vue?vue&type=script&lang=ts&setup=true"

import "./FilterUsers.vue?vue&type=style&index=0&id=7faec0ec&lang=scss&scoped=true"
script.__scopeId = "data-v-7faec0ec"

export default script